import React, { useState, useEffect } from 'react'
import PlanningAddspec from './planningAddspec'
import PreprassEditspec from './planningEditspec'
import FetchApi from '../../../customhooks/functionFetchApi'
import PlanApprove from './planApprove';

const Actionplanning = ({ journalId, codeid, stateflow ,totalspec}) => {
    const FetchApis = new FetchApi();
    const [checkdata, setCheckdata] = useState(false);
    console.log(journalId)
    useEffect(() => {
        // setCheckdata(false)
       
        // setTimeout(() => {
             
              checkdataplanning(journalId);
            //   setCheckdata(true)
        // }, (1000));
       
    }, [])


     function checkdataplanning(ids) {

         FetchApis.FethcGet(`/specplanning/specplanningByJournalId/${ids}`).then((res) => {
                
            if (res.data.data.length > 0) {
                // console.log(res)
                setCheckdata(true)
            } else {
                setCheckdata(false)
            }
        })

    }
    return (
        <div>
           <div className='row-between-page'>
                <div>
                  {totalspec != '0' && <PlanApprove idjournal={journalId} stateflow={stateflow} />}
                </div>
                <div style={{ marginRight: 5 }}>
                    <PlanningAddspec journalId={journalId} />
                </div>
                <div>
                    {totalspec !='0' && <PreprassEditspec journalId={journalId} stateflow={stateflow}/>}
                </div>
            </div>
        </div>
    )
}

export default Actionplanning